<template>
<div>
  <el-button type="secondary" @click="open">수집 설정 키</el-button>
  <w-sliding-popup ref="slidingPopup" :title="targetTitle" top="50px" width="1000px" @close="close">
    <div slot="content">
      <el-tabs slot="content" type="card" v-model="activeTab">
        <el-tab-pane label="장비" name="objKeySettingList" class="h100 w100">
          <w-obj-key-setting-list :obj-info="objInfo" :agent-obj-id="agentObjId" :basicinfo-set-list="basicinfoSetList" ref="objKeySettingList"></w-obj-key-setting-list>
        </el-tab-pane>
        <el-tab-pane label="자원" name="objRscKeySettingList" class="h100 w100">
          <w-obj-rsc-key-setting-list :obj-info="objInfo" :agent-obj-id="agentObjId" :basicinfo-set-list="basicinfoSetList" ref="objRscKeySettingList"></w-obj-rsc-key-setting-list>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div slot="footer">
      <el-row type="flex" justify="center">
        <el-button class="mr-r4" type="solid" size="large" @click="onSaveButtonClick">저장</el-button>
        <el-button size="large"  @click="close">취소</el-button>
      </el-row>
    </div>
  </w-sliding-popup>
</div>
</template>

<script>
import basicinfoSetAPI from '@/api/model/basicinfo-set';
import { forEach } from 'lodash';
import WObjKeySettingList from './ObjKeySettingList';
import WObjRscKeySettingList from './ObjRscKeySettingList';

export default {
  name: 'WObjRscKeySettingPopup',
  components: {
    WObjKeySettingList,
    WObjRscKeySettingList,
  },
  props: {
    objInfo: {
      type: Object,
    },
    agentObjId: Number,
  },
  data() {
    return {
      targetTitle: '',
      activeTab: 'objKeySettingList',
      basicinfoSetList: {},
    };
  },
  methods: {
    open() {
      this.$nextTick(() => {
        this.activeTab = 'objKeySettingList';
        this.targetTitle = `[${this.objInfo.obj.objName}] 수집 설정 키`;
        this.targetBasicinfoSetList = {};
        const list = ['CARD_ADDRESS', 'CHANNEL_ADDRESS', 'MODULE_ADDRESS', 'PORT_ADDRESS'];
        if (this.objInfo.obj.objManagetypeId === 'FMS') {
          list.push(this.objInfo.obj.objtypeId);
        }
        new Promise((resolve) => {
          forEach(list, (item) => {
            basicinfoSetAPI.getList(item).then((res) => {
              if (res.data.data) {
                const target = this.convertToSettingData(res.data.data);
                this.targetBasicinfoSetList[item] = target;
              }
            });
          });
          resolve();
        }).then(() => {
          this.basicinfoSetList = this.targetBasicinfoSetList;
          this.$refs.slidingPopup.open();
        });
      });
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
    onSaveButtonClick() {
      if (this.activeTab === 'objKeySettingList') {
        this.$refs.objKeySettingList.onSaveButtonClick();
      } else {
        this.$refs.objRscKeySettingList.onSaveButtonClick();
      }
    },
    convertToSettingData(targetList) {
      forEach(targetList, (item, index) => {
        let targetValue = '';
        if (item.datatypeId === 'BOOL') {
          if (item.basicinfoSubvalueBoolean === '0') {
            targetValue = false;
          } else {
            targetValue = true;
          }
        } else if (item.datatypeId === 'INTEGER') {
          targetValue = item.basicinfoSubvalueInteger;
        } else if (item.datatypeId === 'STRING') {
          targetValue = item.basicinfoSubvalueString;
        }
        targetList[index].basicinfoSubValue = targetValue;
      });
      return targetList;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/ObjRscKeySettingPopup.vue